import React from "react";

const words = [
  "HOUSES",
  "FACTORIES",
  "HIGH-RISE SOCIETIES",
  "SHOPPING MALLS",
  "HOSPITALS",
  "GOVERNMENT BUILDINGS",
  "SCHOOLS",
  "HOTELS",
];

export default function Marquee() {
  const items = [...words, ...words];
  return (
    <section className="bg-[#0A0A0A] text-white overflow-hidden border-y border-zinc-800">
      <div className="marquee-track py-6">
        {items.map((w, i) => (
          <div key={i} className="flex items-center gap-8 px-8 whitespace-nowrap">
            <span className="font-mono text-2xl md:text-4xl uppercase tracking-tight font-medium">
              {w}
            </span>
            <span className="w-3 h-3 bg-[#FF5F1F] rotate-45 shrink-0" />
          </div>
        ))}
      </div>
    </section>
  );
}
